var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [{ name: "dropdown", rawName: "v-dropdown" }],
      staticClass:
        "form-group with-icon-right dropdown select-form-group multiselect-form-group",
      class: { "has-error": _vm.hasErrors() },
    },
    [
      _c("div", { staticClass: "input-group dropdown-toggle" }, [
        _c("input", {
          class: { "has-value": !!_vm.displayValue },
          attrs: { readonly: "", required: "" },
          domProps: { value: _vm.displayValue },
        }),
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
        _c("i", { staticClass: "bar" }),
        _c(
          "small",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasErrors(),
                expression: "hasErrors()",
              },
            ],
            staticClass: "help text-danger",
          },
          [_vm._v(_vm._s(_vm.showRequiredError()) + "\n    ")]
        ),
        _c("i", {
          staticClass:
            "ion ion-ios-arrow-down icon-right input-icon dropdown-ion",
        }),
      ]),
      _vm.isClearable
        ? _c("div", [
            _c("i", {
              staticClass:
                "fa fa-close icon-cross icon-right input-icon multiselect-form-group__unselect",
              on: { click: _vm.unselectOptions },
            }),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dropdown-menu",
          attrs: { "aria-labelledby": "dropdownMenuButton" },
        },
        [
          _c("scrollbar", { ref: "scrollbar" }, [
            _c(
              "div",
              { staticClass: "dropdown-menu-content" },
              _vm._l(_vm.options, function (option, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "dropdown-item",
                    class: { selected: _vm.isOptionSelected(option) },
                    on: {
                      click: function ($event) {
                        return _vm.toggleSelection(option)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "ellipsis" }, [
                      _vm._v(
                        _vm._s(_vm.optionKey ? option[_vm.optionKey] : option)
                      ),
                    ]),
                    _c("i", { staticClass: "fa fa-check selected-icon" }),
                  ]
                )
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }